// extracted by mini-css-extract-plugin
export default {"answerContainer":"AnswerMultipleChoice_answerContainer__SvrKZ","answerText":"AnswerMultipleChoice_answerText__8CaJT"};